import { useQuery } from '@tanstack/react-query';
import {
  fetchListaDocumentosSimples,
  type SimplesNacionalFiltro,
} from '../api/ListaDocumentosSimplesApi';

export function useListaDocumentosSimples(filtro: SimplesNacionalFiltro, enabled: boolean) {
  return useQuery({
    queryKey: ['lista-documentos-simples', filtro],
    queryFn: () => fetchListaDocumentosSimples(filtro),
    enabled,
    staleTime: 30_000,
  });
}
